import { IColumn, IDocumentTable, IRow, IRows } from '@models/Forms/IForms';
import { collectTableColumns, TableColumnKind } from '@molecules/formbuilder/controls/Table/controls/tableColumns';

const collections: Record<
    TableColumnKind,
    keyof Pick<IColumn, 'fields' | 'dicts' | 'abooks' | 'calcs' | 'autoCompletes' | 'urls'>
> = {
    field: 'fields',
    exds: 'fields',
    dict: 'dicts',
    abook: 'abooks',
    calc: 'calcs',
    autocomplete: 'autoCompletes',
    url: 'urls',
};

export const generateTableFormScheme = (table: IDocumentTable): IRows => {
    const rows: IRow[] = collectTableColumns(table)
        .filter(({ column }) => !column.hidden)
        .map(
            ({ column, kind }) =>
                ({
                    columns: [{ [collections[kind]]: [{ ...column }] } as unknown as IColumn],
                }) as IRow,
        );
    return { rows: { row: rows } } as IRows;
};
